export const buildDigitalPrSearchPayload = (keyword, selection = {}) => ({
  keyword,
  location_country_target_id: selection.countryTargetId,
  location_region_target_id: selection.regionTargetId || null,
  location_target_id: selection.locationTargetId,
  geo_match_mode: 'strict',
});
